import { render, staticRenderFns } from "./DetalleTraspaso.vue?vue&type=template&id=39230cee&scoped=true"
import script from "./DetalleTraspaso.vue?vue&type=script&lang=js"
export * from "./DetalleTraspaso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39230cee",
  null
  
)

export default component.exports